import { useCreatePartyMutation } from "Api/Mutations/Party/useCreatePartyMutation";
import { useCreatePartyRelationMutation } from "Api/Mutations/Party/useCreatePartyRelationMutation";
import type { RelationType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

type Props = {
  onSuccess?: (partyPublicID: string) => void;
  onError?: () => void;
  relationType: RelationType;
  owningPartyID: string;
};

export const useCreatePartyWithRelation = ({
  onSuccess,
  onError,
  relationType,
  owningPartyID,
}: Props) => {
  const { t } = useResource();
  const { mutateAsync: postPartyRelation, isPending: isCreatingPartyRelation } =
    useCreatePartyRelationMutation();

  const {
    mutate: postPartyWithRelation,
    mutateAsync: postPartyWithRelationAsync,
    isPending: isCreatingParty,
  } = useCreatePartyMutation({
    onSuccess: async (relatedPartyPublicID) => {
      try {
        await postPartyRelation({
          partyPublicID: owningPartyID,
          data: {
            relationType,
            relatedPartyPublicID,
          },
        });
        onSuccess?.(relatedPartyPublicID);
      } catch {
        toast.error(t(Resources.Errors.UnknownError));
      }
    },
    onError,
  });

  return {
    postPartyWithRelation,
    postPartyWithRelationAsync,
    isPending: isCreatingParty || isCreatingPartyRelation,
  };
};
